export default "__VITE_ASSET__D38rZLoq__"